export const EndpointTypes = { ADMIN: 'a', END_USER: 'eu', ANONYMOUS: 'anno' };

const Endpoints = {
  [EndpointTypes.ADMIN]: {
    getForm: formId => `/forms/v1/forms/${formId}`,
    getIntegrations: formId =>
      `/scheduler/v1/integration?query=[[{"field":"'assetId'","op":"=","value":"${formId}"},{"field":"'active'","op":"=","value":"true"}]]`,
    getRules: formId =>
      `/forms/v1/rules?query=[[{"field":"'formId'","op":"=","value":"${formId}"}]]`,
    getUserInput: (submissionId, formId) =>
      `/forms/v1/forms/${formId}/submissions/${submissionId}`,
    postIntegration: () => `/scheduler/v1/integration`,
    postSubmission: () => `/forms/v1/eusubmissions`,
    submit: (sId, formId) =>
      `/forms/v1/forms/${formId}/submissions/${sId}/submit`,
    fileUpload: (formId, sId, internalId) =>
      `/forms/v1/eusubmissions/${formId}/${sId}/upload/${internalId}`,
    saveSubmission: (sId, formId) =>
      `/forms/v1/forms/${formId}/submissions/${sId}`,
    calculate: formId => `/forms/v1/public/eusubmissions/${formId}/calculate`
  },
  [EndpointTypes.END_USER]: {
    getForm: formId => `/forms/v1/eu/forms/${formId}`,
    getIntegrations: formId =>
      `/scheduler/v1/eu/integration?query=[[{"field":"'assetId'","op":"=","value":"${formId}"},{"field":"'active'","op":"=","value":"true"}]]`,
    getRules: formId =>
      `/forms/v1/rules?query=[[{"field":"'formId'","op":"=","value":"${formId}"}]]`,
    getUserInput: submissionId => `/forms/v1/eusubmissions/${submissionId}`,
    postSubmission: () => `/forms/v1/eusubmissions`,
    submit: sId => `/forms/v1/eusubmissions/${sId}/submit`,
    fileUpload: (formId, sId, internalId) =>
      `/forms/v1/eusubmissions/${formId}/${sId}/upload/${internalId}`,
    saveSubmission: sId => `/forms/v1/eusubmissions/${sId}/autosave`,
    calculate: formId => `/forms/v1/public/eusubmissions/${formId}/calculate`
  },
  [EndpointTypes.ANONYMOUS]: {
    getForm: formId => `/forms/v1/public/forms/${formId}`,
    getRules: formId => `/forms/v1/public/rules?formId=${formId}`,
    postSubmission: formId => `/forms/v1/public/forms/${formId}/eusubmissions`,
    submit: (sId, formId) =>
      `/forms/v1/public/forms/${formId}/eusubmissions/${sId}/submit`,
    fileUpload: (formId, sId, internalId) =>
      `/forms/v1/public/forms/${formId}/eusubmissions/${sId}/upload/${internalId}`,
    calculate: formId => `/forms/v1/public/eusubmissions/${formId}/calculate`
  }
};

const getApiEndpoints = endpoint => {
  if (endpoint && Endpoints[endpoint]) {
    return Endpoints[endpoint];
  }
  return Endpoints[getEndpointType()];
};

export const getEndpointType = () => {
  const urlPath = window.location.pathname;

  if (urlPath.includes('dashboard') || urlPath.includes('assigned')) {
    return EndpointTypes.END_USER;
  }
  if (urlPath.includes('responses') || urlPath.includes('form-preview')) {
    return EndpointTypes.ADMIN;
  }
  return EndpointTypes.ANONYMOUS;
};

export default getApiEndpoints;
